export default [
	{
		modulo: 3,
		privilegio: 3,
		routerName: 'monitoramento',
		routerPath: '/monitoramento',
		componentName: 'Monitoramento',
		componentPath: 'modules/layout/monitoramento/main'
	},
	{
		modulo: 3,
		privilegio: 3,
		routerName: 'monitoramento-quadrantes',
		routerPath: '/monitoramento-quadrantes',
		componentName: 'MonitoramentoQuadrante',
		componentPath: 'modules/layout/monitoramento/quadrante/main'
	},
]

